import PublicUser from './PublicUser.jsx';
import './PublicUser.css';

export default PublicUser;
